module.exports = __webpack_public_path__ + "static/media/SOLDEMEXICO_6mayo.7a92b9c0.jpg";